type SplitParagraphsProps = {
  paragraph?: string;
  prefix?: string;
  className?: string;
};

const SplitParagraphs = ({
  paragraph,
  prefix,
  className,
}: SplitParagraphsProps) => {
  return (
    <>
      {paragraph?.split("\n").map((val, index) => (
        <p key={index} className={className}>
          {index === 0 && prefix && <>{prefix} </>}
          {val}
        </p>
      ))}
    </>
  );
};

export default SplitParagraphs;
